<template>
    <!-- 1388弹框 -->
    <van-popup class="act-six-one-eight-pop-box" position="bottom" :value="showActAlwaysDiscountPop" :close-on-click-overlay=false >
        <div class="act-six-one-eight-pop act-six-one-eight-fullpage-pop">
            <!-- 顶部会员特权列表 -->
            <div class="act-six-one-eight-vip-title-bg"><div class="act-six-one-eight-vip-title"></div></div>
            <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
            <div id="ActAlwaysDiscountContentBox" class="act-six-one-eight-vip-content-box"><div class="act-six-one-eight-vip-content"></div></div>
            <div id="ActAlwaysDiscountBgBox" class="act-six-one-eight-bg" :style="activityInfo ? 'background-image: url('+activityInfo.img_1388+')' : ''"></div>
            <div class="act-six-one-eight-content">
                <div class="my-vip-bottom-list">
                    <div class="my-vip-bottom-l-item-box">
                        <div class="my-vip-bottom-l-item" :class="{'selected': selectedIndex == 4}" @click="selectItem(4)">
                            <p class="p1">活动价</p>
                            <p class="p2">￥<span class="num">{{vipProductData['pay_40020'] ? vipProductData['pay_40020'].price : ''}}</span></p>
                            <div class="item-note item-note-2" v-if="selectedIndex == 4"></div>
                            <div class="item-select" v-if="selectedIndex == 4"></div>
                        </div>
                    </div>
                    <div class="my-vip-bottom-l-item-box">
                        <div class="my-vip-bottom-l-item" :class="{'selected': selectedIndex == 2}" @click="selectItem(2)">
                            <p class="p1">日常价</p>
                            <p class="p2">￥<span class="num">{{vipProductData['pay_40002'] ? vipProductData['pay_40002'].price : ''}}</span></p>
                            <p class="p3 p4">任性购买</p>
                            <div class="item-note item-note-4" v-if="selectedIndex == 2"></div>
                            <div class="item-select" v-if="selectedIndex == 2"></div>
                        </div>
                    </div>
                </div>
                <div class="act-six-one-eight-button">
                    <button class="act-button last"  @click="clickButton">立即购买</button>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils'
import { CONFIG } from '../../modules/config';
export default {
    name: 'VantActivityAlwaysDiscountPop',
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        showActAlwaysDiscountPop() {
            return this.$store.state.activity.showActAlwaysDiscountPop;
        },
        activityInfo() {
            return this.$store.state.activity.activityInfo;
        },
        actCountDownTime() {
            return this.$store.state.activity.actCountDownTime;
        },
        actCountDownTimeStr1() {
            return this.$store.state.activity.actCountDownTimeStr1;
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        },
        actCountDownNumber() {
            return this.$store.state.activity.actCountDownNumber;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            selectedIndex: 4
        }
    },
    methods: {
        clickClose() {
            this.$store.state.activity.showActAlwaysDiscountPop = false;
            this.$store.dispatch('activity/updateActivityShowBtnStatus');
            this.$store.dispatch('reminder/udpateExtList', {
                params: {"act_h5_618_pop": 1}
            });
        },
        selectItem(pIndex) {
            this.selectedIndex = pIndex;
        },
        clickButton() {
            let me = this,
                userVip = this.$store.state.userData.info.vip,
                pData = this.selectedIndex == 4 ? this.vipProductData['pay_40020'] : this.vipProductData['pay_40002'],
                curPath = this.$router.history.current.path,
                detailInfo = this.$store.state.detail.personInfo;
            console.log('clickButton----', this.selectedIndex, userVip, pData.pid);
            if(pData.pid == 'pay_40020') {
                MIX.trackButtonClicked('buy_1388_bt_(save)');
            }
            
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: pData.pid,
                    ptype: pData.payType[2],
                    discount: CONFIG.vip_discount
                },
                mixParams: {
                    pid: pData.pid,
                    product_name: pData.title,
                    price: pData.price,
                    from: 'pop_1388',
                },
                sucCb: function() {
                    console.log('支付VIP成功');
                    // 更新数据
                    if(detailInfo) {
                        if(curPath.indexOf('report') != -1) {
                            me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                        }else if(curPath.indexOf('nature') != -1) {
                            me.$store.dispatch('report/getAiCharacter', {
                                detailInfo: detailInfo
                            });
                        }
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.activity.showActAlwaysDiscountPop = false;
                    me.$store.state.user.showVipSucPop = true;
                    me.$set(me.$store.state.userData, 'vip', 30);
                    me.$set(me.$store.state.userData.info, 'vip', 30);
                    me.$store.state.user.curSelectPayType = 30;
                    me.$bus.emit('updateMyVipInfo');
                },
                failCb: function() {
                    console.error('支付失败----')
                    // me.$toast('支付失败,请稍后再尝试~')
                }
            });
        }
    }
}
</script>